import { apiEndpoints } from '@/apiEndpoints';
import { ActivityResponse } from '../types/benefits/ActivityResponse';
import { SupportedLocale } from '@/types/supported-locale.type';
import axios from 'axios';

export const createActivity = async (data: FormData) =>
  axios.post(apiEndpoints.activities.base, data);

export const updateActivity = async (
  benefitId: string,
  data: FormData,
  language?: SupportedLocale,
) =>
  axios.put(apiEndpoints.activities.detail(benefitId), data, {
    params: { language },
  });

export const getCities = async (country?: string) => {
  const result = await axios.get(apiEndpoints.activities.cities, {
    params: { country },
  });
  return result.data;
};

export const getActivity = async (benefitId: string) => {
  const result = await axios.get<ActivityResponse>(
    apiEndpoints.activities.detail(benefitId),
  );
  return result.data;
};

export const duplicateActivity = async (
  benefitId: string,
  fields: string[],
) => {
  const result = await axios.post(
    apiEndpoints.activities.duplicate(benefitId),
    { fields },
  );
  return result.data;
};
